'use client'
import logoPrimary from "@/assets/img/logo.webp";
import logoSecondary from "@/assets/img/logo-2.webp";
import {Link} from "@/i18n/routing";
import {useTranslations} from 'next-intl';
import {useCommonDataContext} from '@/providers/CommonDataContext';
import LogoImage from '@/components/layout/headers/LogoImage';

export default function Logo({ home, contact, sticky, headerStyle, navBg, catalogPage }) {
  const { common } = useCommonDataContext();
  const t = useTranslations('header');
  return (
    <div className={sticky ? "sticky-logo" : "col pe-0"}>
      <div className={`${headerStyle === 5 ? "" : "site-logo-wrap"}`}>
        <LogoImage
            logoSrc={navBg === "secondary" && sticky
                ? (home?.secondaryLogo ?? common?.home?.secondaryLogo ?? logoSecondary)
                : headerStyle === 2
                    ? (home?.secondaryLogo ?? common?.home?.secondaryLogo ?? logoSecondary)
                    : (home?.primaryLogo ?? common?.home?.primaryLogo ?? logoPrimary)
            }
        />
        {headerStyle === 5 ? ("") : (
            contact || common?.contact ? (
                <div className={`get-support clearfix ${headerStyle === 2 ? "get-support-color-white" : ""} ${catalogPage ? 'get-support-active' : ''}`}>
                  <div className="get-support-icon">
                    <i className="icon-call"></i>
                  </div>
                  <div className="get-support-info">
                    <h6>{t('getSupport')}</h6>
                    <h4>
                      <Link href={`tel:${contact?.parsedTelNumber ?? common?.contact?.parsedTelNumber}`}>
                        {contact?.telNumber ?? common?.contact?.telNumber}
                      </Link>
                    </h4>
                  </div>
                </div>
            ) : ''
        )}
      </div>
    </div>
  );
};
